export default __webpack_public_path__ + "assets/models/2e851ff1439f8192c5f7311646962e55.glb";